import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-learn-completed-dialog',
  templateUrl: './learn-completed-dialog.component.html',
  styleUrls: ['./learn-completed-dialog.component.css']
})
export class LearnCompletedDialogComponent implements OnInit {

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<LearnCompletedDialogComponent>) { }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close(true);
  }

}
